// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { DepositFragment } from './deposit.fragment.generated';
export type InvoiceToDepositFragment = { __typename?: 'InvoiceToDepositDTO', amount: number, depositId: number, invoiceId: number, deposit: { __typename?: 'DepositDTO', amount: number, block: string | null, date: LocalDate, depositInvoiceId: number | null, depositUseId: number | null, holderId: number | null, holderType: Types.InvoiceHolderTypeDto | null, id: number, ownerCorporateDataId: number | null, ownerId: number, paymentId: number | null, reservationId: number | null, username: string | null } };

export const InvoiceToDepositFragment = gql`
    fragment InvoiceToDeposit on InvoiceToDepositDTO {
  amount
  depositId
  invoiceId
  deposit {
    ...Deposit
  }
}
    ${DepositFragment}`;
/* eslint-enable */